import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'

const HoverLink = styled(Link)`
  color: black;
  &:hover {
    opacity: .7;
  }
`

// const HoverLink = styled(({className, ...props}) => <BaseHoverLink {...props} activeClassName={className} />)`
//   opacity: .8;
// `;

export default HoverLink



// WEBPACK FOOTER //
// ../components/styled/HoverLink.js